<template>
  <ion-select v-if="roundSelection.length > 1" class="mt-20 mb-2 ml-2 round-filter" placeholder="Select Round" v-model="filterRound">
    <ion-select-option v-for="round in roundSelection" :key="round.value" :value="round.value">{{ round.text }}</ion-select-option>
  </ion-select>
  <!-- <table-grid-mobile-with-search title="Test Mobile Table" :headers="['Goal', 'Penalty', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8', 'T9', 'T10', 'T11', 'T12']"
  :rows="[
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  ]"/> -->
  <table-grid-mobile-with-search
  :title="sportLadder.label"
  v-if="isMultiSport"
  :headers="sportLadder.headers"
  :rows="sportLadder.rows"/>
  <ion-list class="mt-20 mb-2 ladder-wrapper" lines="none" v-if="
    useSortOptions === false &&
    get(ladder, 'competition.laddertemplate.useSortOptions', false) === false &&
    !isMultiSport &&
    ((ladder.competition && !ladder.competition.hasPools)
    ||
    (ladder.competition && ladder.competition.hasPools && (!teamsByPool || Object.keys(teamsByPool) === 0)))
  ">
    <ion-item class="header-row">
      <ion-label class="place">
        <ion-text >
          <span class="stats-header">
            No.
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="ion-text-wrap team-name">
        <ion-text>
          <span class="stats-header">
            Name
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header">
        <ion-text class="stats-header">
          <span >
            Pl
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header">
        <ion-text class="stats-header">
          <span>
            W
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header">
        <ion-text class="stats-header">
          <span>
            D
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header">
        <ion-text class="stats-header">
          <span>
            L
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header team-bp" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed">
        <ion-text>
          <span class="stats-header">
            BP
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header team-pts">
        <ion-text>
          <span class="stats-header">
            Pts
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header">
        <ion-text>
          <span class="stats-header">
            +
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header">
        <ion-text>
          <span class="stats-header">
            -
          </span>
        </ion-text>
      </ion-label>
    </ion-item>
    <div class="team-wrapper" v-for="(team, index) in teamsArrangeByPosition" :key="team._id">
      <ion-item @click="flipDisplay(team._id)">
        <ion-label class="place">
        <ion-text>
          <span class="stats">
            {{ index + 1 }}
            <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
            </svg>
          </span>
        </ion-text>
        </ion-label>
        <ion-label class="ion-text-wrap team-name">
          <ion-text>
            <span class="stats">
              {{ team.name }}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats">
          <ion-text>
            <span class="stats">
              {{ team.stats.matchesPlayed }}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats">
          <ion-text>
            <span class="stats">
              {{ team.stats.matchesWon }}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats">
          <ion-text>
            <span class="stats">
              {{ team.stats.matchesDrawn }}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats">
          <ion-text>
            <span class="stats">
              {{ team.stats.matchesLost }}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed">
          <ion-text>
            <span class="stats">
              {{ team.stats.pointsBonus }}
            </span>
          </ion-text>
        </ion-label>
         <ion-label class="stats">
          <ion-text>
            <span class="stats stats-pts">
              {{ team.stats.totalMatchPoints >= 0 ? `${team.stats.totalMatchPoints}` : `${team.stats.totalMatchPoints}`}}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats">
          <ion-text>
            <span class="stats stats-pts">
              {{ team.stats.pointsFor }}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats">
          <ion-text>
            <span class="stats stats-pts">
              {{ team.stats.pointsAgainst }}
            </span>
          </ion-text>
        </ion-label>
      </ion-item>
      <transition-group name="fade">
        <ion-item v-show="ladder.teams.find(t => t._id === team._id).display" :key="key" lines="none">
          <ion-label class="stats">
            <ion-text><span class="stats"> Diff : {{ team.stats.pointsDifference >= 0 ? `+${team.stats.pointsDifference}` : `${team.stats.pointsDifference}`}} </span></ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text><span class="stats"> B : {{ team.stats.byes }} </span></ion-text>
          </ion-label>
        </ion-item>
      </transition-group>
    </div>

  </ion-list>


  <ion-list class="mt-20 mb-2 ladder-wrapper" lines="none" v-if="
    useSortOptions === true &&
    !isMultiSport &&
    ((ladder.competition && !ladder.competition.hasPools)
    ||
    (ladder.competition && ladder.competition.hasPools && (!teamsByPool || Object.keys(teamsByPool) === 0)))
  ">
    <ion-item class="header-row">
      <ion-label class="place">
        <ion-text >
          <span class="stats-header">
            No.
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="ion-text-wrap team-name">
        <ion-text>
          <span class="stats-header">
            Name
          </span>
        </ion-text>
      </ion-label>
      <ion-label class="stats-header" v-for="header in headersSelected">
        <ion-text class="stats-header">
          <span >
            {{ header }}
          </span>
        </ion-text>
      </ion-label>
    </ion-item>
    <div class="team-wrapper" v-for="(team, index) in teamsArrangeByPosition" :key="team._id">
      <ion-item @click="flipDisplay(team._id)">
        <ion-label class="place">
          <ion-text>
            <span class="stats">
              {{ index + 1 }}
              <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
              </svg>
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="ion-text-wrap team-name">
          <ion-text>
            <span class="stats">
              {{ team.name }}
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats" v-for="value in teamStats(team)">
          <ion-text>
            <span class="stats stats-pts">
              {{ value }}
            </span>
          </ion-text>
        </ion-label>
      </ion-item>
      <transition-group name="fade">
        <ion-item v-show="ladder.teams.find(t => t._id === team._id).display" :key="key" lines="none">
          <ion-label class="stats">
            <ion-text><span class="stats"> Diff : {{ team.stats.pointsDifference >= 0 ? `+${team.stats.pointsDifference}` : `${team.stats.pointsDifference}`}} </span></ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text><span class="stats"> B : {{ team.stats.byes }} </span></ion-text>
          </ion-label>
        </ion-item>
      </transition-group>
    </div>

  </ion-list>

  <div v-if="useSortOptions === true &&
    !isMultiSport &&
    (ladder.competition && ladder.competition.hasPools)">
    <ion-list
      class="mt-20 mb-2 ladder-wrapper" lines="none"
      :hidden="isMultiSport"
      v-for="pool in filteredPools"
      :key="processPoolNameSortOptions(pool)">
      <ion-list-header class="pool-name"> {{ processPoolName(pool) }} </ion-list-header>
      <ion-item class="header-row">
        <ion-label class="place">
          <ion-text >
            <span class="stats-header">
              No.
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="ion-text-wrap team-name">
          <ion-text>
            <span class="stats-header">
              Name
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header" v-for="header in headersSelected">
          <ion-text class="stats-header">
            <span >
              {{ header }}
            </span>
          </ion-text>
        </ion-label>
      </ion-item>
      <div class="team-wrapper" v-for="(team, index) in teamsByPool[pool]" :key="team._id">
        <ion-item @click="flipDisplay(team._id)">
          <ion-label class="place">
            <ion-text>
              <span class="stats">
                {{ index + 1 }}
                <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
                </svg>
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="ion-text-wrap team-name">
            <ion-text>
              <span class="stats">
                {{ team.name }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats" v-for="value in teamStats(team)">
            <ion-text>
              <span class="stats stats-pts">
                {{ value }}
              </span>
            </ion-text>
          </ion-label>
        </ion-item>
        <transition-group name="fade">
          <ion-item v-show="ladder.teams.find(t => t._id === team._id).display" :key="key" lines="none">
            <ion-label class="stats">
              <ion-text><span class="stats"> Diff : {{ team.stats.pointsDifference >= 0 ? `+${team.stats.pointsDifference}` : `${team.stats.pointsDifference}`}} </span></ion-text>
            </ion-label>
            <ion-label class="stats">
              <ion-text><span class="stats"> B : {{ team.stats.byes }} </span></ion-text>
            </ion-label>
          </ion-item>
        </transition-group>
      </div>

    </ion-list>
  </div>

  <div v-else>
    <ion-list
      class="mt-20 mb-2 ladder-wrapper" lines="none"
      :hidden="isMultiSport"
      v-for="pool in filteredPools"
      :key="processPoolName(pool)">
      <ion-list-header class="pool-name"> {{ processPoolName(pool) }} </ion-list-header>
      <ion-item class="header-row">
        <ion-label class="place">
          <ion-text >
            <span class="stats-header">
              No.
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="ion-text-wrap team-name">
          <ion-text>
            <span class="stats-header">
              Name
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header">
          <ion-text class="stats-header">
            <span >
              Pl
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header">
          <ion-text class="stats-header">
            <span>
              W
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header">
          <ion-text class="stats-header">
            <span>
              D
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header">
          <ion-text class="stats-header">
            <span>
              L
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header team-bp" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed">
          <ion-text>
            <span class="stats-header">
              BP
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header team-pts">
          <ion-text>
            <span class="stats-header">
              Pts
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header">
          <ion-text>
            <span class="stats-header">
              +
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header">
          <ion-text>
            <span class="stats-header">
              -
            </span>
          </ion-text>
        </ion-label>
      </ion-item>
      <div class="team-wrapper" v-for="(team, index) in teamsByPool[pool]" :key="team._id">
        <ion-item @click="flipDisplay(team._id)">
          <ion-label class="place">
          <ion-text>
            <span class="stats">
              {{ index + 1 }}
              <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
              </svg>
            </span>
          </ion-text>
        </ion-label>
          <ion-label class="ion-text-wrap team-name">
            <ion-text>
              <span class="stats">
                {{ team.name }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text>
              <span class="stats">
                {{ team.stats.matchesPlayed }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text>
              <span class="stats">
                {{ team.stats.matchesWon }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text>
              <span class="stats">
                {{ team.stats.matchesDrawn }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text>
              <span class="stats">
                {{ team.stats.matchesLost }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed">
            <ion-text>
              <span class="stats">
                {{ team.stats.pointsBonus }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text>
              <span class="stats stats-pts">
                {{ team.stats.totalMatchPoints >= 0 ? `${team.stats.totalMatchPoints}` : `${team.stats.totalMatchPoints}`}}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text>
              <span class="stats stats-pts">
                {{ team.stats.pointsFor }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats">
            <ion-text>
              <span class="stats stats-pts">
                {{ team.stats.pointsAgainst }}
              </span>
            </ion-text>
          </ion-label>
        </ion-item>
        <transition-group name="fade">
          <ion-item v-show="ladder.teams.find(t => t._id === team._id).display" :key="key" lines="none">
            <ion-label class="stats">
              <ion-text><span class="stats"> Diff : {{ team.stats.pointsDifference >= 0 ? `+${team.stats.pointsDifference}` : `${team.stats.pointsDifference}`}} </span></ion-text>
            </ion-label>
            <ion-label class="stats">
              <ion-text><span class="stats"> B : {{ team.stats.byes }} </span></ion-text>
            </ion-label>
          </ion-item>
        </transition-group>
      </div>

    </ion-list>
  </div>

</template>

<script>
import _ from 'lodash';
import TableGridMobileWithSearch from '@/components/TableGridMobileWithSearch';

const sortBy = [
  { name: 'Total Match Points', value: 'totalMatchPoints', abbreviation: 'Pts' },
  { name: 'Points Difference', value: 'pointsDifference', abbreviation: '+/-' },
  { name: 'Points For', value: 'pointsFor', abbreviation: '+' },
  { name: 'Points Against', value: 'pointsAgainst', abbreviation: '-' },
  { name: 'Points Bonus', value: 'pointsBonus', abbreviation: 'BP' },
  { name: 'Matches Played', value: 'matchesPlayed', abbreviation: 'P' },
  { name: 'Matches Won', value: 'matchesWon', abbreviation: 'W' },
  { name: 'Matches Lost', value: 'matchesLost', abbreviation: 'L' },
  { name: 'Matches Drawn', value: 'matchesDrawn', abbreviation: 'D' },
  { name: 'BYES', value: 'byes', abbreviation: 'B' },
  { name: 'Score Ratio', value: 'scoreRatio', abbreviation: 'SR' },
  { name: 'Points Ratio', value: 'pointsRatio', abbreviation: 'PR' },
  { name: 'Number Of Forfeits', value: 'numberOfForfeits', abbreviation: 'FF' },
  { name: 'Number Forfeits Win', value: 'numberForfeitsWin', abbreviation: 'FW' },
  { name: 'Number Forfeits Loss', value: 'numberForfeitsLoss', abbreviation: 'FL' },
  { name: 'Points Difference Percentage', value: 'pointsDifferencePercentage', abbreviation: '%' },
];

export default {
  name: 'LadderView',
  components: {
    TableGridMobileWithSearch
  },
  props: {
    ladder: {
      type: Object,
      required: true,
    },
    sportLadder: {
      type: Object,
      required: false,
    },
    selectedPool: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      key: 0,
      get: _.get,
      filterRound: 0,
    }
  },
  mounted() {
    console.log('LadderView mounted', this.ladder);
  },
  methods: {
    processPoolName(name) {
      return name !== 'undefined' ? name : 'Unknown Pool';
    },
    processPoolNameSortOptions(name) {
      return name !== 'undefined' ? name : 'Unknown Pool';
    },
    flipDisplay(teamId) {
      if (!this.ladder.teams) return;
      const index = this.ladder.teams.findIndex(t => t._id === teamId);
      if (this.ladder.teams[index].display) {
        // eslint-disable-next-line vue/no-mutating-props
        this.ladder.teams[index].display = false;
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.ladder.teams[index].display = true;
      }
      this.key++
    },
    teamStats(team) {
      const teamStats = _.get(team, 'stats', {});
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      // const sortBy = _.get(this.ladder, 'competition.laddertemplate.sortBy', []);
      let selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortOptionsSorted', []);
      if (useSortOptionsCompType) {
        selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortOptionsSorted', []);
      }
      // const filterSortBy = _.filter(sortBy, (item) => _.includes(selectedSortByOptions, item.value));
      const stats = [];
      for (const item of selectedSortByOptions) {
        const value = _.get(teamStats, item, 0);
        stats.push(value);
      }
      return stats;
    }
  },
  computed: {
    roundSelection() {
      const maxRound = _.get(this.ladder, 'teamsWithStatsByRound.maxRound', 0);
      const rounds = [];
      rounds.push({
        text: 'All Rounds',
        value: 0,
      });
      // eslint-disable-next-line no-restricted-syntax
      for (let i = 1; i <= maxRound; i++) {
        rounds.push({
          text: `Round ${i}`,
          value: i,
        });
      }
      return rounds;
    },
    selectedSortByOptions() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      if (useSortOptionsCompType) {
        return _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortByOptions', []);
      }
      return _.get(this.ladder, 'competition.laddertemplate.selectedSortByOptions', []);
    },
    useSortOptions() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      if (useSortOptionsCompType) {
        const selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortOptionsSorted', []);
        return useSortOptionsCompType && selectedSortByOptions.length > 0;
      }
      const selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortOptionsSorted', []);
      return _.get(this.ladder, 'competition.laddertemplate.useSortOptions', false) && selectedSortByOptions.length > 0;
    },
    headersSelected() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      let selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortOptionsSorted', []);
      if (useSortOptionsCompType) {
        selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortOptionsSorted', []);
      }
      console.log({
        headersSelected: selectedSortByOptions,
      });
      const filterSortBy = [];
      for (const item of selectedSortByOptions) {
        const foundItem = _.find(sortBy, (sortByItem) => {
          console.log({
            sortByItemValue: sortByItem.value,
            item,
          });
          return sortByItem.value === item
        });
        console.log({
          item,
          foundItem,
        });
        if (foundItem) filterSortBy.push(foundItem);
      }
      console.log({
        sortBy,
        filterSortBy,
        selectedSortByOptions,
      });
      const mappedHeaders = _.map(filterSortBy, (item) => {
        const header = _.get(item, 'abbreviation');
        if (header) return header;
        // Get name, get first letter of each word
        const name = _.get(item, 'name', '');
        return name.split(' ').map((word) => word[0]).join('');
      });
      console.log({
        mappedHeaders,
        selectedSortByOptions,
        filterSortBy,
      });
      return mappedHeaders;
    },
    teamsByPool() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      let selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortByOptions', []);
      if (useSortOptionsCompType) {
        selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortByOptions', []);
      }
      const mapStatArrange = _.map(selectedSortByOptions, (item) => {
        return `stats.${item}`;
      });
      const iteratees = selectedSortByOptions.map(item => `stats.${item}`);
      const orders = selectedSortByOptions.map(() => 'desc');
      const arrangePriority = [
        ...mapStatArrange,
      ];
      // const { teams } = this.ladder;
      let teams = [];
      const roundSelected = this.filterRound;
      if (roundSelected === 0) {
        teams = _.orderBy(this.ladder.teams, iteratees, orders);
      } else {
        teams = _.get(this.ladder, `teamsWithStatsByRound.perRound.${roundSelected}`, []);
        teams = _.orderBy(teams, iteratees, orders);
      }
      return teams
        ? teams.reduce((result, item) => {
          const value = item.pool;
          // eslint-disable-next-line no-param-reassign
          result[value] = (result[value] || []).concat(item);
          return result;
        }, {}) : false;
    },
    isMultiSport() {
      const headers = _.get(this.sportLadder, 'headers', []);
      const rows = _.get(this.sportLadder, 'rows', []);
      if (headers.length > 0 && rows.length > 0) {
        return true;
      }
      return false;
    },
    teamsArrangeByPosition() {
      // console.log({
      //   ladder: this.ladder,
      // });
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      let selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortByOptions', []);
      if (useSortOptionsCompType) {
        selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortByOptions', []);
      }
      const mapStatArrange = _.map(selectedSortByOptions, (item) => {
        return `stats.${item}`;
      });
      const arrangePriority = [
        ...mapStatArrange,
      ];
      const checkIfPositionExists = (teams) => {
        return teams.some((team) => {
          const position = _.get(team, 'position', false);
          return position !== false && position !== null && position !== undefined;
        });
      };
      // console.log({
      //   arrangePriority
      // });
      // console.log({
      //   selectedSortByOptions
      // });
      const iteratees = selectedSortByOptions.map((item) => `stats.${item}`);
      const orders = selectedSortByOptions.map(() => 'desc');
      const roundSelected = this.filterRound;
      if (roundSelected === 0) {
        // if (checkIfPositionExists(this.ladder.teams)) {
        //   return arrangePriority.unshift('position');
        // }
        return _.orderBy(this.ladder.teams, iteratees, orders);
      }
      // if (checkIfPositionExists(_.get(this.ladder, `teamsWithStatsByRound.perRound.${roundSelected}`, []))) {
      //   return arrangePriority.unshift('position');
      // }
      const roundTeams = _.get(this.ladder, `teamsWithStatsByRound.perRound.${roundSelected}`, []);
      return _.orderBy(roundTeams, iteratees, orders);
    },
    isAllPools() {
      // Check if no pool is selected or if "All Pools" is selected
      return !this.selectedPool || this.selectedPool.name === 'All Pools';
    },
    filteredPools() {
      if (!this.teamsByPool) {
        return [];
      }

      if (this.isAllPools) {
        // Filter out undefined keys and ensure we have valid pools
        const validPools = Object.keys(this.teamsByPool).filter(key =>
          key !== 'undefined' &&
          this.teamsByPool[key] &&
          Array.isArray(this.teamsByPool[key]) &&
          this.teamsByPool[key].length > 0
        ).sort(); // Sort alphabetically
        return validPools;
      } else if (this.selectedPool) {
        return [this.selectedPool.name];
      }
      return [];
    },
  }
};
</script>

<style scoped lang="scss">

/* Assemble Sports Fonts */
@font-face {
	font-family: 'BrownStd-Bold';
	src: url('../assets/fonts/BrownStd-Bold.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Regular';
	src: url('../assets/fonts/BrownStd-Regular.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Light';
	src: url('../assets/fonts/BrownStd-Light.otf') format('truetype'); /* IE9 Compat Modes */
}

.fade-enter-active,
.fade-leave-active {
  transition: all .5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

{
  opacity: 0;
  height: 0;
}

.team-name {
  min-width: 6rem;
  width: 6rem;
}

.team-pts {
  min-width: 1.2rem;
  width: 1.2rem;
}

.team-bp {
  min-width: 1.2rem;
  width: 1.2rem;
}

.team-diff {
  min-width: 1.4rem;
  width: 1.4rem;
}

.ladder-wrapper {
  border-radius: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-bottom: 1.5rem;
  /* box-shadow:
  0 0.4px 0.4px rgba(0, 0, 0, 0.016),
  0 1px 1px rgba(0, 0, 0, 0.022),
  0 2.1px 2.1px rgba(0, 0, 0, 0.028),
  0 4.4px 4.4px rgba(0, 0, 0, 0.034),
  0 12px 12px rgba(0, 0, 0, 0.05)
; */
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
}

.stats {
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: normal;
  font-size: 0.7rem;
  line-height: 1rem;
  /* identical to box height, or 123% */

  text-align: center;

  color: white;
  text-overflow: clip;
}

.stats-pts {
  font-family: 'BrownStd-Bold';
  font-weight: bold;
}

.pool-name {
  font-family: "BrownStd-Regular";
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
}

.stats-header {
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: .8rem;
  line-height: 1rem;
  /* identical to box height, or 114% */

  text-align: center;

  color: white;
  text-overflow: clip;
}

ion-list, ion-item {
  background: transparent;
  --background: transparent;
}

.round-filter {
  // --background: #1E1E1E;
  --color: white;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: normal;
  font-size: 1.2rem;
  // line-height: 1rem;
  /* identical to box height, or 123% */

  // text-align: center;

  color: white;
  margin: 0 2rem 0 1rem;
}



</style>
